import React, { Component } from 'react'
import { Spin, Table, Typography } from "antd";
const { Text } = Typography
export default class InactiveMaintenanceTable extends Component {

    componentDidMount() {
        //document.getElementById('container').scrollIntoView();

        var tableContent = document.querySelector('.inactive .ant-table-body')
        tableContent && tableContent.addEventListener('scroll', (event) => {
            let maxScroll = event.target.scrollHeight - event.target.clientHeight
            let currentScroll = Math.ceil(event.target.scrollTop)
            if ((event.target.scrollTop + event.target.clientHeight >= event.target.scrollHeight - 100) && (maxScroll !== 0 && currentScroll !== 0) && (currentScroll >= maxScroll && (maxScroll !== 0 && currentScroll !== 0))) {
                this.props.getInactiveMaintenanceSchedules()
            }
        })
    }

    render() {
        const { loading, dataSource, tableLoading, count, columns } = this.props;
        const fetchedRecords = dataSource[dataSource.length - 1]?.index || 0;
        return (
            <Spin spinning={loading}>
                <Table
                    size='middle'
                    className="responsive-container inactive"
                    rowClassName={(record) => (`scroll-row-${record.id}`)}
                    scrollToFirstRowOnChange={true}
                    rowKey={(record) => record.id}
                    bordered
                    scroll={{ y: 550, x: 2000 }}
                    dataSource={dataSource}
                    columns={columns}
                    loading={tableLoading}
                    onChange={(...rest) => this.props.handleSortChange(false, ...rest)}
                    pagination={false}
                    footer={() => <>{fetchedRecords !== 0 && <div style={{ textAlign: 'center' }}>
                        <Text strong>Fetched {fetchedRecords} out of {count} inactive Schedule Maintenances</Text>
                    </div>}
                    </>}
                />
            </Spin>
        )
    }
}
